<template>
    <ion-list class="flash-messages" v-show="flashMessages && flashMessages.length">
        <ion-item class="flash-message" :class="{pointer: flash.route}" v-for="flash in flashMessages" :route="flash.route" v-bind:key="flash.id" :color="flash.type || 'primary'"
                  @click="flashClicked(flash.id, $event)">
            <ion-text>{{ flash.message }}</ion-text>
        </ion-item>
    </ion-list>
</template>

<script>
    import {DELETE_FLASH_MESSAGE} from "../../const/mutation-types";
    import {ADD_FLASH_MESSAGE} from "../../const/mutation-types";

    export default {
        name: "FlashMessages",
        methods: {
            flashClicked(id, event) {
                if (event.currentTarget.getAttribute('route')) {
                    this.$router.push({name: event.currentTarget.getAttribute('route')});
                } else {
                    this.$store.commit(DELETE_FLASH_MESSAGE, id);
                }
            }
        },
        computed: {
            flashMessages() {
                return this.$store.getters.flashMessages;
            },
        },
        created() {
            if (this.$route.query.flash) {
                this.$store.commit(ADD_FLASH_MESSAGE, {
                    message: this.$route.query.flash,
                    type: 'success',
                });
                history.replaceState(
                    {},
                    null,
                    this.$route.path
                )
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .flash-messages {
        margin: 5px 0;
        background: transparent;
        position: relative;
        z-index: 2;
    }
    .flash-message {
        margin: 5px 0;
    }
    .pointer {
        cursor: pointer;
    }
    @media (max-width: 767px) {
        .flash-message {
            font-size: 85%;
        }
    }
</style>
